(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-luxe-contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var launcher = event.target.closest('[data-bl-chat-launcher]');
    if (!launcher) return;
    var chatHost = document.querySelector('shopify-chat');
    var chatButton = document.querySelector('button[aria-label="Chat"]');
    if (!chatButton && chatHost && chatHost.shadowRoot) {
      chatButton = chatHost.shadowRoot.querySelector('button');
    }
    if (chatButton) chatButton.click();
  });

  } catch(e) { console.error(e); }
})();
})();
